<template>
  <transition name="modal" v-if="isShow">
    <div class="modal-mask" @click.stop.self="closable ? close : ''">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">&nbsp;</slot>
            <a v-if="closable" class="times" @click="close">
              <span/>
              <span/>
            </a>
          </div>
          <div class="modal-body">
            <slot>
              default body
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'Modal',
  props: {
    closable: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    isShow: false,
  }),
  methods: {
    show(){
      this.isShow = true;
    },
    close(){
      this.isShow = false;
      this.$emit('close');
    },
  },
  computed: {},
};
</script>
<style lang="scss">
  $breakpoint: 500px;

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: flex;
    align-items: center;
    transition: opacity .3s ease;
    overflow: auto;
  }

  .modal-wrapper {
    margin: auto;
    max-width: 800px;
    @media (max-width: $breakpoint) {
      width: 100%;
    }
    @media (min-width: $breakpoint) {
      min-width: 500px;
    }
  }

  .modal-container {
    width: 100%;
    margin: 0px auto;
    /* padding: 20px 30px; */
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
  }

  .modal-header {
    background: #0059a9;
    padding: 10px 15px 10px 20px;
    color: #eee;
    font-size: 15pt;
    > a {
      float: right;
    }
  }

  .modal-body {
    margin: 0;
  }

  .modal-footer {
    padding: 0px 10px;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .times {
    width: 25px;
    height: 30px;
    cursor: pointer;
    > span {
      width: 100%;
      height: 2px;
      background-color : #fff;
      display: inline-block;

      &:nth-of-type(1) {
        transform : translateY(-7px) rotate(-45deg);
      }
      &:nth-of-type(2) {
        transform : translateY(-34px) rotate(45deg);
      }
    }
  }

  // .times {
  //   span {
  //     position : absolute;
  //     width : 20px;
  //     height : 2px;
  //     background-color : #fff;
  //     border-radius : 4px;
  //
  //     &:nth-of-type(1) {
  //       -webkit-transform : translateY(15px) rotate(-45deg);
  //       transform : translateY(15px) rotate(-45deg);
  //     }
  //     &:nth-of-type(2) {
  //       -webkit-transform : translateY(15px) rotate(45deg);
  //       transform : translateY(15px) rotate(45deg);
  //     }
  //   }
  // }

</style>
